import { useQuery } from "@tanstack/react-query";

import { globalCarrierSchema } from "~/shared/schemas/auto-dispatch-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const getAutoDispatchableCarriers = async (signal?: AbortSignal) => {
	const signalOptions = signal ? { signal } : undefined;
	const resp = await getAndValidate(
		apiRoutes.GETGLOBALAUTODISPATCHABLECARRIERS,
		globalCarrierSchema.array(),
		signalOptions,
	);

	if (resp.success) {
		return resp.data;
	} else {
		throw new Error(
			`Failed to fetch auto-dispatchable carriers: ${resp.error}`,
		);
	}
};

export const useGetGlobalCarriers = () => {
	const {
		data: globalCarriers,
		error: globalCarriersError,
		isLoading: globalCarriersIsLoading,
	} = useQuery({
		queryKey: ["globalAutoDispatchableCarriers"],
		queryFn: async ({ signal }: { signal: AbortSignal }) =>
			getAutoDispatchableCarriers(signal),
		staleTime: 0,
		gcTime: 0,
		refetchOnWindowFocus: false,
	});

	return {
		globalCarriers,
		globalCarriersError,
		globalCarriersIsLoading,
	};
};
